export function FillClockIcon() {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M15.3033 15.3033C13.8968 16.7098 11.9891 17.5 10 17.5C8.01088 17.5 6.10322 16.7098 4.6967 15.3033C3.29018 13.8968 2.5 11.9891 2.5 10C2.5 8.01088 3.29018 6.10322 4.6967 4.6967C6.10322 3.29018 8.01088 2.5 10 2.5C11.9891 2.5 13.8968 3.29018 15.3033 4.6967C16.7098 6.10322 17.5 8.01088 17.5 10C17.5 11.9891 16.7098 13.8968 15.3033 15.3033ZM11.25 5C11.25 4.66848 11.1183 4.35054 10.8839 4.11612C10.6495 3.8817 10.3315 3.75 10 3.75C9.66848 3.75 9.35054 3.8817 9.11612 4.11612C8.8817 4.35054 8.75 4.66848 8.75 5V10C8.75 10.6901 9.30986 11.25 10 11.25H14C14.3315 11.25 14.6495 11.1183 14.8839 10.8839C15.1183 10.6495 15.25 10.3315 15.25 10C15.25 9.66848 15.1183 9.35054 14.8839 9.11612C14.6495 8.8817 14.3315 8.75 14 8.75H11.25V5Z'
        fill='currentColor'
        stroke='currentColor'
      />
    </svg>
  );
}
